import _ from 'lodash';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import LoadingSpinner from '../../../../components/LoadingSpinner';
import LeaveForm from './LeaveForm';
import { getEmployees } from '../../../../actions/HumanResources/employeeActions';
import { createLeave } from '../../../../actions/HumanResources/leaveRequestActions';

const LeaveCreate = (props) => {
	const { datas, loading } = props;
	useEffect(() => {
		props.getEmployees();
	}, []);
	const onSubmit = (formValues) => {
		if (!_.isEmpty(formValues)) {
			props.createLeave(formValues);
		}
	};
	return (
		<>
			{loading ? (
				<LoadingSpinner />
			) : (
				<div className="mt-3">
					<LeaveForm datas={datas} onSubmit={onSubmit} />
				</div>
			)}
		</>
	);
};
const mapStateToProps = (state) => {
	const {
		humanResources: {
			employee: { employees, getEmployeesLoading },
		},
	} = state;
	return { datas: { employees }, loading: getEmployeesLoading };
};
export default connect(mapStateToProps, { getEmployees, createLeave })(LeaveCreate);
